import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
} from "@angular/core";
import { OnboardProfessionalReferenceDetails } from "src/app/shared/models/OnboardProfessionalReferenceDetails";
import { MatDialog } from "@angular/material";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import { OnboardingService } from "src/app/shared/service/onboarding.service";
import { ComponentIdentificationService } from "src/app/shared/service/component-identification.service";
import { isUndefined } from "util";
import { EmployeeService } from "src/app/shared/service/employee.service";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-reference-details",
  templateUrl: "./reference-details.component.html",
  styleUrls: ["./reference-details.component.css"],
})
export class ReferenceDetailsComponent implements OnInit, OnChanges {
  referenceDetails: any[] = [];
  result: any;
  newAttribute: any = {};
  @Input() EmpId: number;
  @Input() empCode: number;
  error: any;
  @Output("referenceDetValue") referenceDetValue = new EventEmitter();
  parentComponentName: string;
  referenceDtlsDisable: boolean = false;
  isLoader: boolean = true;

  constructor(
    public dialog: MatDialog,
    private _service: OnboardingService,
    private changeCom_svc: ComponentIdentificationService,
    private emp_Svc: EmployeeService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }


  ngOnChanges() {
    this.changeCom_svc.componentName.subscribe(
      (response) => (this.parentComponentName = response)
    );
    if (this.parentComponentName == "app-hr-employee-details") {
      if (!isUndefined(this.empCode)) {
        this.GetHREmpReferences();
      }
    } else {
      this.GetOnboardEmpReferences();
    }
  }

  getRefreshPage(){
    window.location.reload();
  }

  addFieldValue() {
    this.referenceDetails.push(this.newAttribute);
    this.newAttribute = {};
  }
  deleteFieldValue(index) {
    const message = `Please confirm if you want delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(
      " ",
      message,
      deleteType
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.referenceDetails.splice(index, 1);
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }
  GetOnboardEmpReferences() {
    this.referenceDetails = [];
    this._service.GetOnboardEmpReferences(this.EmpId).subscribe(
      (data: any) => {
        if (data != null && data.length != 0) {
          this.referenceDetails = data;
        } else {
          this.addFieldValue();
        }
        this.referenceDetValue.emit(this.referenceDetails);
      },
      (error) => (this.error = error)
    );
  }
  GetHREmpReferences() {
    this.referenceDetails = [];
    this.emp_Svc.getEmployeeReferenceDetails(this.empCode).subscribe(
      (data: any) => {
        if (data != null && data.length != 0) {
          this.referenceDetails = data;
        } else {
          this.addFieldValue();
        }
        this.referenceDetValue.emit(this.referenceDetails);
      },
      (error) => (this.error = error)
    );
  }
}
